// extracted by mini-css-extract-plugin
export var optionGrid = "_8x-7";
export var optionList = "_8x-6";
export var questionsBlock = "_8x-9";
export var spacer = "_8x-5";
export var stepCenteredContent = "_8x-3";
export var stepInner = "_8x-0";
export var stepInnerFullWidth = "_8x-1";
export var stepInnerLockScroll = "_8x-2";
export var stepTransitionFrame = "_8x-4";
export var welcomeBlock = "_8x-8";